module.exports = __webpack_public_path__ + "img/20.8d3eb90e.jpg";